export default __webpack_public_path__ + "static/media/151-antennas.8ef9a14b.png";